import Reference from 'rlink-data-connector/storage/Reference';
import CACHES_SHAPE from 'rlink-data-connector/storage/CACHES_SHAPE';
import ConstructableContainer from 'rlink-data-connector/storage/ConstructableContainer';
import {copyGenerator, isIterable} from 'rlink-data-connector/storage/collections';
import warnOnce from 'rlink-debug-utils/warnOnce';

export default function _resolveValue (caches, resolveSet, referenceValue) {

  if (referenceValue instanceof Reference) {
    if (referenceValue in resolveSet) {
      let resolveSetValue = resolveSet[referenceValue];
      let {isResolved, resolvedValue, resolveRef} = resolveSetValue;
      if (isResolved) {
        return resolvedValue;
      } else {
        if (resolveSetValue.isResolving) {
          throw new Error(`Circular resolution for ${resolveRef}!`);
        }
        resolveSetValue.isResolving = true;
        let referredRefValue = CACHES_SHAPE.getAt(caches, referenceValue.storagePath('reference'));
        let resolved = _resolveValue(caches, resolveSet, referredRefValue);

        resolveSetValue.isResolving = false;
        resolveSetValue.isResolved = true;
        resolveSetValue.resolvedValue = resolved;

        return resolved;
      }
    } else {
      // referenced values outside the resolveSet should already be up to date
      // - just look them up
      let onMissingKey = undefined;

      if (referenceValue.optional) {
        onMissingKey = () => {
          warnOnce(`Reference points to non-existent value ${referenceValue}`);
          return null;
        };
      }

      return CACHES_SHAPE.getAt(caches, referenceValue.storagePath('resolved'),
                                undefined, onMissingKey);
    }
  } else if (referenceValue instanceof ConstructableContainer) {
    let hasResolutionDifference = false;
    let resolvedData = copyGenerator(referenceValue.data,
      function *(constructValue, entries) {
        for (let [key, value] of entries) {
          let resolvedValue = _resolveValue(caches, resolveSet, value);
          if (resolvedValue !== value) {
            hasResolutionDifference = true;
          }
          yield constructValue(key, resolvedValue);
        }
      }
    );
    return referenceValue.constructInstance(referenceValue.type, hasResolutionDifference ? resolvedData : referenceValue.data);
  } else if (isIterable(referenceValue)) {
    let hasResolutionDifference = false;
    let resolvedIterable = copyGenerator(referenceValue,
      function *(constructValue, entries) {
        for (let [key, value] of entries) {
          let resolvedValue = _resolveValue(caches, resolveSet, value);
          if (resolvedValue !== value) {
            hasResolutionDifference = true;
          }
          yield constructValue(key, resolvedValue);
        }
      }
    );
    return hasResolutionDifference ? resolvedIterable : referenceValue;
  } else {
    return referenceValue;
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/storage/_resolveValue.js